export const listInvoices = `
   query listInvoices($filter: InvoicesFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              customerId
              customer {
                id
                name
              }
              subscriptionId
              invoiceUrl
              created
              createdByUsername
              updated
           }
           nextToken
       }
   }
`;

export const getInvoice = `
   query getInvoice($id:ID!) {
       getInvoice(id:$id) {
         id
         customerId
         customer {
           id
           name
         }
         subscriptionId
         invoiceUrl
         created
         createdByUsername
         createdByUser {
           name
           givenName
           familyName
           email
         }
         updated
       }
}`;
